import { render, staticRenderFns } from "./PayPopup.vue?vue&type=template&id=8fbfb4c6&scoped=true&"
import script from "./PayPopup.vue?vue&type=script&lang=js&"
export * from "./PayPopup.vue?vue&type=script&lang=js&"
import style0 from "./PayPopup.vue?vue&type=style&index=0&id=8fbfb4c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbfb4c6",
  null
  
)

export default component.exports